<template>
    <div class="assignment-step" v-if="canViewStep">

        <div class="page-content">
            <a href="#" @click.prevent="showReflectiontips(assignment)" class="button-rounded button-rounded--reflection button-rounded--teachertips" v-if="shouldShowReflectiontips"><span class="icon icon--reflection"></span>reflection</a>

            <group-submissions :assignment="assignment" :group="group" :isExcerpt="false" :isInspecting="isInspecting"></group-submissions>
        </div>

        <nav class="action-nav">
            <hr class="flipped">
            <router-link :to="prevStepLink" class="tag button-timid button-backward">Vorige stap</router-link>
            <primary-button :link="returnLink.route" class="action-nav__next" >Klaar</primary-button>
        </nav>

    </div>
</template>


<script>

import GroupSubmissions from 'js/components/assignment/presenters/GroupSubmissions.vue'
import PrimaryButton from'js/components/elements/PrimaryButton.vue'
import track from 'js/helpers/analytics'
import { canTeach } from 'js/api/auth';
import step from './stepMixin'

export default {
    name: 'Group',
    components: { GroupSubmissions, PrimaryButton },
    mixins: [ step ],

    props: {
        assignment: {},
        group: {},
        isInspecting: {
            type: Boolean,
            default: false,
        },
        returnLink: {
            type: Object,
            required: true
        }
    },

    vuex: {
        actions: {

            showReflectiontips: ({dispatch}, assignment) => {
                track.event('reflectiontips', 'show', assignment.id)
                dispatch('SHOW_MODAL', 'Reflectiontips')
            }

        }
    },

    computed: {

        isTeacher: function() {
            return canTeach(this.$store.state.users.current)
        },

        shouldShowReflectiontips: function() {
            return this.isTeacher && this.assignment.reflectiontips === true
        },

        canViewStep: function() {
            return this.isProgressFinished(this.progress)
        },

        prevStepLink: function() {
            if ( this.isInspecting ) {
                return { name: 'assignment.step', params: { stepIdx: this.assignment.steps.length }}
            }
            return { name: 'assignment.overview' }
        },

    },
    methods: {
        checkRoute: function() {

            if ( ! this.canViewStep ) {
                this.autoRedirectStep(this.progress)
            }

        },
    },
    created: function() {
        this.checkRoute()
    }
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// StepGroup.vue?5e1bee4b